import React from 'react'
import { HashRouter, Route } from 'react-router-dom'

import Gallery from './components'

const GalleryRouter = ({ app }) => (
    <HashRouter>
        <Route path="/:parentTag?" component={(props) => (<Gallery {...props} app={app} />)} />
    </HashRouter>
)

export default GalleryRouter
